const EXCLUDED_RUSTORE_PRODUCT_KODS = new Set([`148735`, `148734`])

/** Показывать блок «Без приложения RuStore» для категорий Apple. */
export const getIsShowRustoreBlock = (categoryCode?: string, productKod?: string): boolean => {
	if (!categoryCode) return false

	return (
		!!categoryCode.match(/iphone|mac|ipad|watch/) &&
		!EXCLUDED_RUSTORE_PRODUCT_KODS.has(productKod ?? ``) &&
		categoryCode !== `remeshki-dlya-iphone`
	)
}
